import * as types from '../mutation-types'

// state
export const state = {
  loadedCss: []
};

// getters
export const getters = {
  loadedCss: state => state.loadedCss
};

// mutations
export const mutations = {
  [types.STORE_CSS](state, cssId) {
    state.loadedCss.push(cssId);
  },

  [types.CLEAR_CSS](state) {
    for (let prevCss in state.loadedCss) {
      let prevStyle = document.getElementById(state.loadedCss[prevCss]);
      if (prevStyle) {
        prevStyle.parentNode.removeChild(prevStyle);
      }
    }
  },
};

// actions
export const actions = {
  pushCssId({commit, dispatch}, payload) {
    commit(types.STORE_CSS, payload)
  },
  clearCss({commit}) {
    commit(types.CLEAR_CSS)
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/css.js